<template>    
    <div>
      <a-table :columns="columns" :data-source="data"
             size="small"
             rowKey="id"
             :scroll="{y:'300px'}"
             :pagination="false"
    >
      <span slot="action" slot-scope="text,record,index">
              <a @click="handleEdit(record)">修改</a>
        <a-divider type="vertical"/>
        <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
                  <a>删除</a>
                </a-popconfirm>
      </span>
    </a-table>
    <a-button  type="primary" @click="handleAdd">添加</a-button>
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <template v-for="(item,index) in model" >
          <a-form-model-item label="字段配置" :key="index">
            <a-select v-model="item.bracketStart" class="info" allowClear>
              <a-select-option :value="bracket" v-for="bracket in brackets" >
                {{bracket}}
              </a-select-option>
            </a-select>
            <a-select v-model="item.id" class="input input2">
              <a-select-option :value="field.id" v-for="field in fieldList" >
                {{field.name}}
              </a-select-option>
            </a-select>
            <a-select v-if="index>0" v-model="item.con" class="info input2" >
              <a-select-option :value="con" v-for="(con) in cons" >
                {{con}}
              </a-select-option>
            </a-select>
            <a-select v-model="item.bracketEnd" class="info input2" allowClear>
              <a-select-option :value="bracket" v-for="bracket in brackets" >
                {{bracket}}
              </a-select-option>
            </a-select>
            <a-button class="input2" icon="plus" @click="addItem(model)"></a-button>
            <a-button v-if="index>0" class="input2" icon="close" @click="removeItem(model,index)"></a-button>
          </a-form-model-item>
        </template>
        <a-form-model-item label="所属中心" v-if="model && model.length">
          <a-select placeholder="请选择研究中心" v-model="formData.centerIds" style="width:90%;" allow-clear showSearch mode="multiple" :filterOption="filterOption">
              <a-select-option v-for="(item,index) in centerList" :key="index" :value="item.centerId">
                {{ item.center.name }}
              </a-select-option>
            </a-select>
            <a-tooltip placement="topLeft" style="padding-left:2px">
                <template slot="title">
                  该规则只适用于选择的中心；未选择中心时，该规则适用项目的所有中心
                </template>
                <a-icon type="info-circle" style="color: #FF4500" />
              </a-tooltip>
        </a-form-model-item>

      </a-form-model>
    </div>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  export default {
    name: 'PatientAgainIn',
    props:{
      projectId:{
        default:''
      },
      fieldList:{
        default:[],
      },
    },
    data(){
      return {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
        formData:{
          centerIds:[],
        },
        data:[],
        model:[],
        rules:{},
        cons:['and','or'],
        brackets:['(',')'],
        columns:[          
          {
            title: '规则',
            align:'center',
            dataIndex: 'checkList',            
            customRender:  (t, r, index)=> {
              let result="";
              t.forEach(item=>{
                var text=""
                if(item.con==="and"){
                  text = "和"
                }else if(item.con==="or"){
                  text = "或者"
                }
                console.log(text)
                result = result +"  " +text+ "  " + (item.bracketStart?item.bracketStart:'') + item.name + (item.bracketEnd?item.bracketEnd:'')
              })
              return result;
            }
          },                 
          {
            title: '研究中心',
            align:'center',
            dataIndex: 'centerName',
            width:260,
            customRender:  (t, r, index)=> {
              let result='所有中心'
              if(t){
                result = t
              }
              return result;
            }
          },          
          {
            title: '操作',
            align:'center',
            width:100,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ],
        centerList: [],
      }
    },
    mounted(){
      // this.loadData()
    },
    methods:{
      loadData(){        
        this.data = []
        if(this.projectId){
          getAction('/project/patientCheck/listAll',{projectId:this.projectId,type:'1'}).then(res=>{
            if(res.success){
              this.data = res.result;
              // if(this.data.expression){
              //   this.model = JSON.parse(this.data.expression)
              // }
            }
          })
          this.loadCenter()
        }
        this.model=[]
      },
      addItem(array){
        array.push(this.getDefaultItem())
      },
      removeItem(array,index){
        array.splice(index,1)
      },
      getData(){
        if(this.formData.centerIds && this.formData.centerIds.length>0){
          this.formData.centerId = this.formData.centerIds.join(',');
        }
        let data = this.formData
        this.model.forEach(item=>{
          this.fieldList.forEach(field=>{
            if(item.id===field.id){
              item.type=field.type
            }
          })
        })
        data.expression = JSON.stringify(this.model)
        data.projectId = this.projectId
        return data
      },
      getDefaultItem(){
        return {
          id:'',
          con:'',
          bracketStart:'',
          bracketEnd:'',
        }
      },
      handleEdit(record){        
        this.formData = record
        if(this.formData.centerId){
          this.formData.centerIds = this.formData.centerId.split(',')
        }
        this.model = record.checkList
      },
      handleDelete(record){
        getAction('/project/patientCheck/del',{id:record.id}).then(res=>{
            if(res.success){
              this.loadData()
              this.$message.success('删除成功!')              
            }else {
              this.$message.error(res.message)
            }
          })
      },
      handleAdd(){
        this.model = [this.getDefaultItem()]
        this.formData = {}
      },
      loadCenter(){
        getAction('/project/center/listAll', { projectId: this.projectId }).then(res => {
          if (res.success) {
            this.centerList = res.result
          }
        })
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>

<style scoped>
  .input{
    width: 200px;
  }
  .info{
    width: 80px;
  }
  .input2{
    margin-left: 10px;
  }
</style>